import api from '@/services/utils/apiInstance'
import { formatDateToApi } from '@/utils/dateUtils'

export class RepairFileService {
  async getPaginatedRepairFileList(search, sort, order, page, limit, filters, signal = undefined) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    const url =
      '/admin/repair-file/list' +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit +
      '&filters=' +
      filters

    const response = await api.get(url, { signal })
    return response.data
  }

  async getRepairFileExport(type, search, sort, order, filters) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    const url =
      '/admin/repair-file/export/' +
      type +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&filters=' +
      filters
    const response = await api.get(url, { responseType: 'blob' })

    return response.data
  }

  async get(repairFileBoomerangId) {
    const response = await api.get('/admin/repair-file/' + repairFileBoomerangId)
    return response.data
  }

  async uploadAdditionalAttachmentFile(data) {
    const response = await api.put('/admin/repair-file/upload-additional-attachment', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getAdditionalAttachmentFileList(repairFileId) {
    const response = await api.get('/admin/repair-file/additional-attachment/list/' + repairFileId)
    return response.data
  }

  async updateRepairFileStatus(repairFileId, date, newStatus, declaration = {}) {
    let data = {
      repairFileId: repairFileId,
      selectedDate: formatDateToApi(date),
      newStatus: newStatus,
      ...declaration
    }

    const response = await api.put('/admin/repair-file/update-status', data)
    return response.data
  }

  async updateRepairFileStatusToReceiptAtStore(
    repairFileId,
    date,
    newStatus,
    clientTakeoverType,
    emailAddress,
    clientPhoneNotificationType,
    smsPhoneNumber,
    pickupPlace
  ) {
    let data = {
      repairFileId: repairFileId,
      selectedDate: formatDateToApi(date),
      newStatus: newStatus,
      clientTakeoverType: clientTakeoverType,
      emailAddress: emailAddress,
      clientPhoneNotificationType: clientPhoneNotificationType,
      smsPhoneNumber: smsPhoneNumber,
      pickupPlace: pickupPlace != '' ? pickupPlace : null
    }

    const response = await api.put('/admin/repair-file/update-status/receipt-at-store', data)
    return response.data
  }

  async getPaginatedRepairFileCommentList(repair_file_boomerang_id, page, limit) {
    const url =
      '/admin/repair-file-comment/' + repair_file_boomerang_id + '?page=' + page + '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async createRepairFileComment(data) {
    const response = await api.post('/admin/repair-file-comment/create', data)
    return response.data
  }

  async deleteRepairFile(data) {
    const response = await api.put('/admin/repair-file/delete', data)
    return response.data
  }

  async manualCloseRepairFile(repairFileBoomerangId, date, comment = null) {
    const data = {
      repairFileBoomerangId,
      selectedDate: formatDateToApi(date),
      comment: comment && comment.trim() !== '' ? comment : null
    }

    const response = await api.put('/admin/repair-file/manual-close', data)
    return response.data
  }

  async getAvailableRepairFileStatusUpdate(repairFileId) {
    const response = await api.get('/admin/repair-file/available-status-update/' + repairFileId)
    return response.data
  }

  async updateRepairFileEmail(data) {
    const response = await api.put('/admin/repair-file/update-email', data)
    return response.data
  }

  async getConfirmCost(repairFileId) {
    const response = await api.get(`/admin/repair-file/${repairFileId}/confirm-cost`)
    return response.data
  }

  async updateConfirmCost(data) {
    const response = await api.put('/admin/repair-file/confirm-cost', data)
    return response.data
  }

  async sendMailReminderToRepairer(data) {
    const response = await api.post('/admin/repair-file/mail-reminder-repairer', data)
    return response.data
  }

  async sendGuaranteeExtensionBoomerangByEmail(send_to, repairFileBoomerangId) {
    let data = {
      email_address: send_to,
      repair_file_boomerang_id: repairFileBoomerangId
    }

    const response = await api.post(
      '/admin/repair-file/send-guarantee-extension-boomerang-email',
      data
    )
    return response.data
  }

  async deleteRepairFileComment(commentId) {
    const response = await api.delete('/admin/repair-file/comment/' + commentId)
    return response.data
  }

  async deleteRepairFileAttachment(repairFileId, attachmentType, attachmentId) {
    if (attachmentId === null) {
      attachmentId = 0
    }

    const response = await api.delete(
      '/admin/repair-file/attachment/' + repairFileId + '/' + attachmentType + '/' + attachmentId
    )
    return response.data
  }

  async getTransporterDocument(repairFileBoomerangId) {
    const response = await api.get(
      '/admin/repair-file/get-transporter-document/' + repairFileBoomerangId,
      {
        responseType: 'blob'
      }
    )
    return response.data
  }

  async finalizationRepairFileUpdate(repairFileId, data) {
    const response = await api.post('/admin/repair-file/finalization/' + repairFileId, data)
    return response.data
  }

  async getUpdateStatusFileTemplate() {
    const response = await api.get('/admin/repair-file/update-status/template', {
      responseType: 'blob'
    })
    return response.data
  }

  async importUpdateStatus(data) {
    await api.post('/admin/repair-file/update-status/import', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async getUploadAdditionalAttachmentQRCodeToken(repairFileId) {
    const response = await api.get(
      '/admin/repair-file/upload-additional-attachment/qr-code-token/' + repairFileId
    )
    return response.data
  }

  async validateRepairFileUploadAdditionalAttachmentQrCodeToken(token) {
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/admin/repair-file/upload-additional-attachment/qr-code-token/validation',
      data,
      { publicCapability: true }
    )

    return response.data
  }

  async uploadAdditionalAttachmentFileFromPublicPage(data) {
    const response = await api.post(
      '/admin/repair-file/upload-additional-attachment/public',
      data,
      {
        publicCapability: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async sendDocumentByEmail(repairFileId, data) {
    const response = await api.post('/admin/repair-file/document-by-email/' + repairFileId, data)
    return response.data
  }

  async deleteByStoreId(storeId, data) {
    const response = await api.post('/admin/repair-file/delete-by-store/' + storeId, data)
    return response.data
  }

  async validateRelaunchStatusToken(token) {
    const data = { token }
    const response = await api.post('/admin/repair-file/relaunch-status/validate-token', data, {
      publicCapability: true
    })
    return response.data
  }

  async getCustomerReceiptContext(token) {
    const response = await api.get('/common/repair-file/customer-receipt/context', {
      params: { token },
      publicCapability: true
    })
    return response.data
  }

  async confirmCustomerReceipt(formData) {
    const response = await api.post('/common/repair-file/customer-receipt', formData, {
      publicCapability: true,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  }

  async submitRelaunchStatus(formData) {
    const response = await api.post('/admin/repair-file/relaunch-status/confirm', formData, {
      publicCapability: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }
}

export default new RepairFileService()
